import { ReactNode } from "react";
import InfoIcon from "../../../../assets/icons/InfoIcon";
import CustomModal from "../../../../components/ui/CustomModal";

export interface ModalConfirmProps {
  open: boolean;
  handleClose: (val?: any) => void;
  title?: ReactNode;
  subTitle?: ReactNode;
  children?: ReactNode;
}

export default function InviteConfirmModal({
  handleClose,
  title,
  subTitle,
  children,
  ...rest
}: ModalConfirmProps) {
  return (
    <CustomModal {...rest} handleClose={handleClose} width={400} footer={null}>
      <div className="flex items-center gap-2">
        <span className="">
          <InfoIcon />
        </span>
        <span className="text-xl font-semibold">{title}</span>
      </div>
      <div className="my-2 mt-3 text-slate-500 text-base font-normal">
        {subTitle}
      </div>
      {children}
    </CustomModal>
  );
}
